import {styled} from "@connectme2/ui";

export const Container = styled.div`
  width: 12.5rem;
  position: relative;
  margin: auto;
  transform: scale(0.5);
`;

